var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PriceComponentNgModule } from '@gn-audio/angularjs-components/price';
import { LocaleComponentNgModule } from '@gn-audio/angularjs-components/locale';
import { WasThisUsefulComponentNgModule } from '@gn-audio/angularjs-components/was-this-useful';
import { setCompatibilityGuideApiConfig } from '@gn-audio/core/api/compatibility-guide/config/actions';
import { setKnowledgeBaseApiConfig } from '@gn-audio/core/api/knowledge-base/config/actions';
import { setPricingApiConfig } from '@gn-audio/core/api/pricing/config/actions';
import { setProductCatalogueApiConfig } from '@gn-audio/core/api/product-catalogue/config/actions';
import { setSiteSettingsApiConfig } from '@gn-audio/core/api/site-settings/config/actions';
import { fetchAuthorizationSetting } from '@gn-audio/core/api/site-settings/fetch-authorization-setting';
import { setWebStoreApiConfig } from '@gn-audio/core/auth/web-store-api/config/actions';
import { copy, isString, module } from 'angular';
import { ngModule as featureCompareModule } from 'cg-feature-compare';
import { ngModule as featureFavouritesModule } from 'cg-feature-favourites';
import { ngModule as featureFormsModule } from 'cg-feature-forms';
import { ngModule as featureMetadataModule } from 'cg-feature-metadata';
import { ngModule as featureSearchModule } from 'cg-feature-search';
import { ngModule as featureSharingModule } from 'cg-feature-sharing';
import { ngModule as featureSummaryBoxModule } from 'cg-feature-summary-box';
import { ngModule as foundationPricingModule } from 'cg-foundation-pricing';
import { StatusMessageComponent } from './components/status-message';
import { ComparePageController } from './controllers/compare-page-controller';
import { DevicesPageController } from './controllers/devices-page-controller';
import { GalleryPageController } from './controllers/gallery-page-controller';
import { SolutionPageController } from './controllers/solution-page-controller';
import { RouteChangeIndicatorDirective } from './directives/route-change-indicator';
import { MarketLocaleInterceptor } from './interceptors/market-locale-interceptor';
import { NgSettingsInterceptor } from './interceptors/ng-settings-interceptor';
import { PartnerKeyInterceptor } from './interceptors/partner-key-interceptor';
import { PricingInterceptor } from './interceptors/pricing-interceptor';
import { VersionInterceptor } from './interceptors/version-interceptor';
import { RouteConfiguration } from './route-configuration';
import { BundleAnalyzer } from './services/bundle-analyzer';
import { History3ProductsService } from './services/history-3-products-products';
import { LocationCartStateService } from './services/location-cart-state';
import { LocationSearchQueryService } from './services/location-filter-query';
import { RoutesHelper } from './services/routes-service';
import { StatusMessageService } from './services/status-message-service';
import '../scss/_master.scss';
module('gn.audio.cg', [
    'ngRoute',
    'ngTouch',
    'ngAnimate',
    'ui.bootstrap',
    featureMetadataModule.name,
    foundationPricingModule.name,
    featureFormsModule.name,
    featureSharingModule.name,
    featureSummaryBoxModule.name,
    featureFavouritesModule.name,
    featureSearchModule.name,
    featureCompareModule.name,
    PriceComponentNgModule.name,
    LocaleComponentNgModule.name,
    WasThisUsefulComponentNgModule.name,
])
    .config([
    '$uibTooltipProvider',
    function ($uibTooltipProvider) {
        $uibTooltipProvider.options({ appendToBody: true });
    },
])
    .config([
    '$sceProvider',
    function ($sceProvider) {
        $sceProvider.enabled(false);
    },
])
    .config([
    '$locationProvider',
    function ($locationProvider) {
        $locationProvider.html5Mode(true);
    },
])
    .config([
    'lazyImgConfigProvider',
    function (lazyImgConfigProvider) {
        lazyImgConfigProvider.setOptions({
            errorClass: 'lazy-img--error',
            successClass: 'lazy-img--success',
        });
    },
])
    .config(['websiteConfiguration', function (websiteConfiguration) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, webStoreAPIBaseUrl, webStoreAPIScopes;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setSiteSettingsApiConfig({
                        baseUrl: "" + websiteConfiguration.settingsApiUrl,
                        marketLocale: websiteConfiguration.marketLocale,
                        siteContext: "jabra",
                    });
                    setCompatibilityGuideApiConfig({ baseUrl: websiteConfiguration.apiUrl, marketLocale: websiteConfiguration.marketLocale });
                    setKnowledgeBaseApiConfig({ baseUrl: websiteConfiguration.knowledgeBaseApiUrl, marketLocale: websiteConfiguration.marketLocale });
                    return [4, setProductCatalogueApiConfig({ baseUrl: websiteConfiguration.productCatalogueApiUrl, marketLocale: websiteConfiguration.marketLocale })];
                case 1:
                    _b.sent();
                    return [4, fetchAuthorizationSetting()];
                case 2:
                    _a = _b.sent(), webStoreAPIBaseUrl = _a.webStoreAPIBaseUrl, webStoreAPIScopes = _a.webStoreAPIScopes;
                    setWebStoreApiConfig({
                        baseUrl: webStoreAPIBaseUrl,
                        marketLocale: websiteConfiguration.marketLocale,
                        siteContext: "jabra",
                        scopes: webStoreAPIScopes,
                        storage: localStorage
                    });
                    return [2];
            }
        });
    }); }])
    .config(['pricingConfiguration', 'websiteConfiguration', function (pricingConfiguration, websiteConfiguration) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, setPricingApiConfig({
                        baseUrl: pricingConfiguration.apiUrl,
                        marketLocale: websiteConfiguration.marketLocale,
                    })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); },])
    .config([
    '$httpProvider',
    function ($httpProvider) {
        $httpProvider.interceptors.push(['$q', 'websiteConfiguration', 'localeService', MarketLocaleInterceptor.Factory]);
        $httpProvider.interceptors.push(['$q', '$cacheFactory', NgSettingsInterceptor.Factory]);
        $httpProvider.interceptors.push(['$q', 'locationService', PartnerKeyInterceptor.Factory]);
        $httpProvider.interceptors.push(['$q', 'websiteConfiguration', PricingInterceptor.Factory]);
        $httpProvider.interceptors.push(['$q', 'websiteConfiguration', VersionInterceptor.Factory]);
    },
])
    .config([
    'wasThisUsefulProvider',
    'websiteConfiguration',
    function (wasThisUsefulProvider, websiteConfiguration) {
        wasThisUsefulProvider.baseUrl(websiteConfiguration.wasThisUsefulServiceUrl);
        wasThisUsefulProvider.marketLocale(websiteConfiguration.marketLocale);
        wasThisUsefulProvider.siteContext("jabra");
    },
])
    .config(RouteConfiguration)
    .run([
    '$rootScope',
    '$location',
    function ($rootScope, $location) {
        var searchObject = copy($location.search());
        Object.keys(searchObject).forEach(function (prop) {
            searchObject[prop.toLowerCase()] = searchObject[prop];
        });
        var partnerKey = searchObject.partnerkey;
        if (!isString(partnerKey) || partnerKey === '') {
            return;
        }
        $rootScope.$on('$locationChangeStart', function (ev, nextUrl, currentUrl) {
            if (nextUrl === currentUrl) {
                return;
            }
            if (/partnerkey=/gi.test(nextUrl)) {
                return;
            }
            $location.search('partnerkey', partnerKey);
        });
    },
])
    .service('bundleAnalyzer', BundleAnalyzer)
    .service('history3Products', History3ProductsService)
    .service('locationCartState', LocationCartStateService)
    .service('locationSearchQuery', LocationSearchQueryService)
    .service('routes', RoutesHelper)
    .service('statusMessage', StatusMessageService)
    .controller('comparePageController', ComparePageController)
    .controller('devicesPageController', DevicesPageController)
    .controller('galleryPageController', GalleryPageController)
    .controller('solutionPageController', SolutionPageController)
    .component('statusMessage', StatusMessageComponent)
    .directive('routeChangeIndicator', RouteChangeIndicatorDirective);
